<template>
	<div>
		<div class="shimmer-overflow" :class="type == 'mobile' ? '' : 'mt-2 p-3'">
			<b-row>
				<b-col
					v-for="(i, index) in shimmer"
					:key="index"
					:cols="bindColumn()"
					class="mb-4 shimmer"
				>
					<b-skeleton type="input"></b-skeleton>
				</b-col>
			</b-row>
			<template v-if="formID == 'personalDetails'">
				<b-row class="mt-2">
					<b-col cols="12">
						<b-skeleton type="input"></b-skeleton>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col cols="12">
						<b-skeleton height="100px" type="input"></b-skeleton>
					</b-col>
				</b-row>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: "FormShimmer",
	data() {
		return {};
	},
	props: {
		type: String,
		shimmer: Number,
		from: String,
		formID: String,
	},
	methods: {
		bindColumn(index) {
			// If the type is "mobile", return 12 (full width)
			if (this.type == "mobile") {
				return "12";
			}

			// If the type is "home", return 6 columns
			if (this.from == "home") {
				return "6";
			}

			// If the index is 0 or 3, return 9 columns
			if (index == 0 || index == 3) {
				return "9";
			}

			// For all other indices, return 4 columns
			return "6";
		},
	},
};
</script>

<style></style>
